/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { SvgIcon, SvgIconProps } from '@material-ui/core';

const LogoutIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="M9.75 2.25H8.25V9.75H9.75V2.25ZM13.3725 3.8775L12.3075 4.9425C13.4925 5.895 14.25 7.3575 14.25 9C14.25 11.9025 11.9025 14.25 9 14.25C6.0975 14.25 3.75 11.9025 3.75 9C3.75 7.3575 4.5075 5.895 5.685 4.935L4.6275 3.8775C3.1725 5.115 2.25 6.945 2.25 9C2.25 12.7275 5.2725 15.75 9 15.75C12.7275 15.75 15.75 12.7275 15.75 9C15.75 6.945 14.8275 5.115 13.3725 3.8775Z" />
  </SvgIcon>
);

export default LogoutIcon;
